/**
 * Triggered when add contact button is clicked from People Card
 */
export const ADD_NEW_CONTACT_BUTTON_CLICKED = 'LaunchAddContact';

/**
 * Triggered when edit contact button is clicked from People Card
 */
export const EDIT_CONTACT_BUTTON_CLICKED = 'LaunchEditContact';

/**
 * Triggered when Cancel button is clicked from Contact Editor screen
 */
export const CANCEL_BUTTON_CLICKED = 'CancelButtonClicked';

/**
 * Triggered when Discard button is clicked after Contact Editor form being dirty
 */
export const DISCARD_BUTTON_CLICKED = 'DiscardButtonClicked';

/**
 * Triggered when changes to a contact are saved, after all service calls.
 */
export const SAVE_CONTACT_COMPLETE = 'SaveContactComplete';

/**
 * Triggered when changes to a contact are completely discarded
 */
export const CONTACT_FORM_DISCARD_COMPLETE = 'ContactFormDiscardComplete';

/**
 * Triggered when Save button is clicked during creating a contact from People Hub screen
 */
export const CREATE_CONTACT_SAVE_BUTTON_CLICKED = 'CreateContactComplete';

/**
 * Triggered when Save button is clicked during adding a contact to your contact list
 */
export const ADD_CONTACT_SAVE_BUTTON_CLICKED = 'AddContactComplete';

/**
 * Triggered when Save button is clicked during updating a contact information
 */
export const EDIT_CONTACT_SAVE_BUTTON_CLICKED = 'SaveEditsComplete';

/**
 * Triggered when a different card is opened from one card
 * Marks the start of INTER_CARD_NAVIGATION_EVENT
 */
export const INTER_CARD_NAVIGATION_BEGIN = 'InterCardNavigationBegin';

/**
 * Triggered every time when PeopleCardModuleWrapper is mounted on a base module
 * Marks the start of PEOPLE_CARD_COLD_START_EVENT
 */
export const PEOPLE_CARD_COLD_LAUNCH_BEGIN = 'PeopleCardColdLaunchBegin';

/**
 * Triggered every time when PeopleCardModuleWrapper is mounted on a base module
 * Marks the start of PEOPLE_CARD_WARM_START_EVENT
 */
export const PEOPLE_CARD_WARM_LAUNCH_BEGIN = 'PeopleCardWarmLaunchBegin';

/**
 * Should be triggered from different cards when the final UI is shows
 * Marks the end of warm start, cold start and inter-card navigation events
 */
export const PEOPLE_CARD_LAUNCH_END = 'PeopleCardLaunchEnd';
